module.exports = __webpack_public_path__ + "img/newicon2click.21c12aa0.svg";